import React from 'react';
import { Link } from "react-router-dom";

import PhoneInput from 'react-phone-input-2';
import Input from '@material-ui/core/Input';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

import { FormValidate, InputContainer, Label, SuccessMessage, ErrorMessage, LoadingContainer, LinksRow, InputHelperText } from './Auth.style';
import AuthHeader from './AuthHeader';
import { Button, CircularProgress } from '@material-ui/core';
import MainAuthComponent from './MainAuthComponent';


const Forgot = ({
    step,
    isLoading,

    phone,
    setPhone,
    code,
    setCode,
    password,
    setPassword,
    confirmedPassword,
    setConfirmedPassword,

    isShowPassword,
    setIsShowPassword,

    isError,
    successMessage,
    errorMessage,
    onClickNext,
}) => {

    const getNextBtnText = (item) => {
        switch (item) {
            case '1':
                return 'Получить код';

            case '2':
                return 'Отправить';

            case '3':
                return 'Отправить';

            default:
                return 'Далее';
        }
    }

    return (
        <MainAuthComponent>
            <>
                <AuthHeader />
                <Label>
                    ВОССТАНОВЛЕНИЕ ПАРОЛЯ
                </Label>
                <FormValidate id="loginForm">
                    {step === '1' &&
                        <InputContainer>
                            <PhoneInput
                                country={'ru'}
                                value={phone}
                                onChange={phone => setPhone(phone)}
                                autoFocus
                                fullWidth
                                variant="filled"
                                id="phone"
                                name="phone"
                                placeholder="Телефон *"
                                error={isError}
                                onKeyDown={onClickNext}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        onClickNext();
                                    }
                                }}
                            />
                        </InputContainer>
                    }
                    {step === '2' &&
                        <InputContainer>
                            <Input
                                value={code}
                                onChange={(e) => setCode(e.target.value)}
                                autoFocus
                                fullWidth
                                variant="filled"
                                required
                                id="smsCode"
                                placeholder="Код из смс *"
                                error={isError}
                            />
                        </InputContainer>
                    }
                    {step === '3' &&
                        <>
                            <InputContainer>
                                <Input
                                    id="password"
                                    name="password"
                                    type={isShowPassword ? 'text' : 'password'}
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    fullWidth
                                    variant="filled"
                                    label="Придумайте пароль *"
                                    placeholder="Придумайте пароль *"
                                    error={isError && !password ? true : false}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={() => setIsShowPassword(!isShowPassword)}
                                            >
                                                {isShowPassword ? <Visibility /> : <VisibilityOff />}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            onClickNext();
                                        }
                                    }}
                                />
                            </InputContainer>
                            <InputHelperText>
                            Пароль должен содержать цифры, строчные и заглавные латинские буквы, знаки препинания
                            </InputHelperText>
                            <InputContainer>
                                <Input
                                    id="conf_password"
                                    name="conf_password"
                                    type={isShowPassword ? 'text' : 'password'}
                                    value={confirmedPassword}
                                    onChange={(e) => setConfirmedPassword(e.target.value)}
                                    fullWidth
                                    variant="filled"
                                    // required
                                    label="Повторите пароль *"
                                    placeholder="Повторите пароль *"
                                    error={isError && !password ? true : false}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={() => setIsShowPassword(!isShowPassword)}
                                            >
                                                {isShowPassword ? <Visibility /> : <VisibilityOff />}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            onClickNext();
                                        }
                                    }}
                                />
                            </InputContainer>
                        </>
                    }

                    <InputContainer>
                        <Button
                            variant="contained"
                            color="secondary"
                            fullWidth
                            type="button"
                            onClick={onClickNext}
                            size='large'
                        >
                            {getNextBtnText(step)}
                            {isLoading && <LoadingContainer><CircularProgress size={20} /></LoadingContainer>}
                        </Button>
                    </InputContainer>
                    <SuccessMessage>{successMessage}</SuccessMessage>
                    <ErrorMessage>{errorMessage}</ErrorMessage>
                    <InputContainer>
                        <LinksRow>

                            <Link to={`${process.env.REACT_APP_WEBSITE_NAME}/register`}>
                                <Button
                                    fullWidth
                                    type="button"
                                >
                                    Регистрация
                            </Button>
                            </Link>
                            •
                            <Link to={`${process.env.REACT_APP_WEBSITE_NAME}/auth`}>
                                <Button
                                    fullWidth
                                    type="button"
                                >
                                    Вход в личный кабинет
                            </Button>
                            </Link>
                        </LinksRow>

                    </InputContainer>
                </FormValidate>
            </>

        </MainAuthComponent>
    )
}

export default Forgot;
